import { MessageSquarePlus } from "lucide-react";

/**
 * La pagina che si apre con «Nuova chat»: pulita, e diversa dalla schermata
 * iniziale.
 *
 * Davide, 27/08: «il tasto + puo' diventare davvero nuova chat, ma deve portare
 * a una pagina pulita, diversa dalla home». Prima il + rimandava alla home:
 * comunicazioni, scorciatoie e domande di prima: tutto giusto quando apri
 * l'app, tutto rumore quando hai gia' in testa la domanda da fare.
 *
 * Non e' vuota del tutto perche' uno schermo bianco sembra un guasto. Due righe
 * spente e basta: il posto d'onore ce l'ha la barra di scrittura.
 */
export function ChatPulita() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <MessageSquarePlus className="h-7 w-7 text-muted-foreground/50" aria-hidden />
      <p className="text-sm text-muted-foreground">
        Nuova conversazione — scrivi qui sotto.
      </p>
    </div>
  );
}
